<template>
  <div class="html_seasonGoalTime" :class="themeClass" v-if="pareData.title">
    <span
      class="theme_publishBtn"
      @click="clickPublish('seasonGoalTime', pareData)"
      v-if="themeClass !== 'broadcastList'"
    >
      <svg
        t="1692698307306"
        class="publishBtn_icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="9670"
        width="50%"
        height="50%"
      >
        <path
          d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
          p-id="9671"
        ></path>
      </svg>
    </span>
    <span class="timeLayout_title" v-text="pareData.title"></span>
    <div class="timeLayout_container">
      <span class="timeColItem" v-for="bar in pareData.barArr" :key="bar.key">
        <span class="timeColItem_top">
          <span class="timeColItem_top_text" v-text="bar.val"></span>
          <span
            class="timeColItem_top_bar"
            :style="{ height: bar.valPer ? `${bar.valPer}vw` : 0 }"
          >
            <i></i>
          </span>
        </span>
        <span class="timeColItem_bottom">
          <span class="timeColItem_bottom_text" v-text="bar.name"></span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// 数据概览 - 进球时间分布
export default {
  name: 'html_seasonGoalTime',
  props: {
    pareData: {
      type: Object,
      default: () => ({
        title: '',
        json: null,
        seasonOrMatch: null,
        barArr: [],
      }),
    },
    themeClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    clickPublish(mode, themeItem) {
      this.$emit('clickPublishEvent', {
        mode,
        themeItem,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.html_seasonGoalTime {
  position: relative;
  width: calc((100% - (2 * 1.388vw)) / 3);
  margin-right: 1.388vw;
  height: 14.583vw;
  color: var(--mixtmt_whiteColor);
  background: linear-gradient(
    90deg,
    var(--mixtmt_mainColor0) 0%,
    var(--mixtmt_mainColor3) 100%
  );
  border-radius: 0.556vw;
  &.broadcastList {
    width: 80%;
    height: 16.93vw;
  }
  &:last-child {
    margin-right: 0;
  }
  .theme_publishBtn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    width: 2.778vw;
    height: 2.778vw;
    line-height: 2.778vw;
    text-align: center;
    opacity: 0.7;
    svg.publishBtn_icon {
      fill: var(--mixtmt_whiteColor);
    }
  }

  .timeLayout_title {
    display: block;
    padding: 1.041vw 0 0 2.083vw;
    font-size: 1.25vw;
    height: 2.773vw;
    font-weight: bold;
  }
  .timeLayout_container {
    display: flex;
    display: -webkit-flex;
    justify-content: space-evenly;
    align-items: flex-start;
    width: 100%;
    height: 8.687vw;
    color: var(--mixtmt_whiteColor);
    .timeColItem {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      .timeColItem_top {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
        height: 5.889vw;
        .timeColItem_top_text {
          font-size: 0.833vw;
          line-height: 1.388vw;
        }
        .timeColItem_top_bar {
          position: relative;
          max-height: 4.5vw;
          height: 0;
          width: 0.556vw;
          transition: height 0.3s linear;
          & > i {
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            border-radius: 0.278vw;
            background-color: var(--mixtmt_cupFootball_customColor1);
          }
        }
      }
      .timeColItem_bottom {
        position: relative;
        height: 5.166vw;
        width: 0.972vw;
        .timeColItem_bottom_text {
          display: block;
          position: absolute;
          top: 0.347vw;
          left: 0;
          z-index: 2;
          width: 100%;
          white-space: nowrap;
          font-size: 0.833vw;
          line-height: 0.972vw;
          transform: rotate(90deg);
        }
      }
    }
  }
}

.mixtmt_pc {
  .html_seasonGoalTime {
    .theme_publishBtn {
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
